/* eslint-disable react/prop-types */
import React from 'react';
import { CheckBox } from 'react-native-elements-light';
import { checkbox, checkboxText } from '~assets/styles/checkboxStyles';
import WithLocalSvg from '@web-components/common/WithLocalSvg';

const RadioDefault = (props) => {
  return (
    <CheckBox
      {...props}
      containerStyle={{ ...checkbox, ...props.containerStyle }}
      textStyle={{ ...checkboxText, ...props.textStyle }}
      checkedIcon={
        props.checkedIcon ? (
          props.checkedIcon
        ) : (
          <WithLocalSvg
            height={20}
            asset={require('~assets/img/common/radio-full-active.svg')}
          />
        )
      }
      uncheckedIcon={
        props.uncheckedIcon ? (
          props.uncheckedIcon
        ) : (
          <WithLocalSvg
            height={20}
            asset={require('~assets/img/common/radio-v2.svg')}
          />
        )
      }
    />
  );
};

export default RadioDefault;
